import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import H6 from '@base/H6/H6';
import Draggable from '@comp/Draggable/Draggable';
import InPageCalculator from '@comp/Calculator/InPageCalculator';
import { Fonts, Spacings } from '@styles/index';
import { calculatorType } from '@constants/index';
import { css } from '@emotion/react';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import Image from '@base/Image';
import {
  getCaclculatorHeight,
  getCaclculatorWidth,
  getPostionX
} from '@cont/Quiz/utils';

const Wrapper = styled.div`
  visibility: ${({ $show }) => !$show && 'hidden'};
`;

const StyledCalculator = styled(InPageCalculator)`
  width: ${(props) => props.$width || '200px'};
  height: ${(props) => props.$height || '400px'};
`;

const CalculatorHeader = styled.div`
  cursor: move;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--color-divider);
  padding: ${Spacings.SPACING_4B};

  ${(props) =>
    props.$isTestRevampFlow &&
    css`
      background-color: var(--color-i-gray-28);
      border-top-left-radius: ${Spacings.SPACING_2B};
      border-top-right-radius: ${Spacings.SPACING_2B};
      background-color: var(--color-i-icon-base-fill);
      padding-bottom: 0;
      > h6 {
        font-size: ${Fonts.SMALL};
        line-height: ${Spacings.SPACING_14};
        font-weight: ${Fonts.BOLD};
      }
    `}
`;

const CalcWrapper = styled.div`
  box-shadow: ${boxShadowGenerator({
    yOffset: Spacings.SPACING_0B,
    color: 'var(--color-divider)',
    spread: Spacings.SPACING_2B
  })};
  border-radius: ${Spacings.SPACING_2B};
  background-color: var(--color-i-gray-28);
`;

const CloseIcon = styled(Image)`
  cursor: pointer;
`;

const DraggableCalculator = ({ show, type, onClose, isTestRevampFlow }) => {
  const isScientific = calculatorType.SCIENTIFIC_CALC === type;
  const title = isScientific ? 'Scientific Calculator' : 'Calculator';

  return (
    <Wrapper $show={show}>
      <Draggable
        posX={getPostionX(isTestRevampFlow, isScientific)}
        posY={
          isTestRevampFlow ? `-${Spacings.SPACING_6}` : Spacings.SPACING_30B
        }
      >
        {({ onMouseDown, onMouseUp, childRef }) => (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <CalcWrapper onMouseDown={onMouseDown} onMouseUp={onMouseUp}>
            <CalculatorHeader $isTestRevampFlow={isTestRevampFlow}>
              <H6>{title}</H6>
              <CloseIcon
                src="/test-revamp/close.png"
                width={16}
                height={16}
                alt="close"
                onClick={onClose}
              />
            </CalculatorHeader>
            <StyledCalculator
              ref={childRef}
              isScientific={isScientific}
              $width={getCaclculatorWidth(isScientific)}
              $height={getCaclculatorHeight(isScientific)}
            />
          </CalcWrapper>
        )}
      </Draggable>
    </Wrapper>
  );
};

export default DraggableCalculator;

DraggableCalculator.propTypes = {
  type: PropTypes.number,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

DraggableCalculator.defaultProps = {
  type: calculatorType.NORMAL_CALC
};
